import { createModuleStore } from '../utils'

export const useFloorsStore = createModuleStore(
  'floors',
  {
    type: 'Location Map',
    pageHeading: 'Location Maps',
    noHistory: true,
    uploadOptionsCsv: '',
    uri: '/floors',
    serviceUri: '/floors',
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    listingModuleName: 'Config',
    listingActivityName: 'View Location Map',
    formModuleName: 'Config',
    formActivityName: 'Edit Location Map',
    allFields: [
      {
        key: 'name',
        title: 'NAME',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'site',
        title: 'SITE',
        type: 'site',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'width',
        title: 'WIDTH',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'height',
        title: 'HEIGHT',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: true,
        sortable: false,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {},
  {
    copy(item) {
      const obj = {
        name: item.name,
        width: item.width,
        height: item.height,
        site: item.site,
      }
      return obj
    },
    resetPageFilters() {
      const store = useFloorsStore()
      store.resetBaseFilters()
    },
  },
  {
    fields: [
      {
        id: 'floor_name',
        name: 'name',
        label: 'Name',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter descriptive floor name' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isNameUnique',
          },
        ],
      },
      {
        id: 'floor_site',
        name: 'site',
        label: 'Site',
        size: 12,
        component: 'SiteSingleSelect',
        visible: true,
        componentProps: {
          placeholder: 'Please select a site represented by this floor',
        },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'floor_image_file',
        name: 'imageBase64',
        label: 'Floor Image',
        size: 24,
        component: '',
        componentProps: {},
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'image_width',
        name: 'width',
        label: 'Width',
        forSubmitOnly: true,
        visible: false,
        size: 12,
        componentProps: {},
      },
      {
        id: 'image_height',
        name: 'height',
        label: 'Height',
        forSubmitOnly: true,
        visible: false,
        size: 12,
        componentProps: {},
      },
    ],
  }
)
